import CryptoJS from 'crypto-js';

const secretKey = 'EggTinaCraftThingWithLove555+';

export const buildTokenizedQueryString = (
  params: Record<string, string | number>,
): string => {
  const jsonString = JSON.stringify(params);
  const ciphertext = CryptoJS.AES.encrypt(jsonString, secretKey).toString();

  const queryParams = new URLSearchParams();
  queryParams.set('token', ciphertext);

  return queryParams.toString();
};

export const detokenizeQueryString = (
  token: string,
): Record<string, string | number> | null => {
  try {
    const bytes = CryptoJS.AES.decrypt(token, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  } catch (error) {
    return null;
  }
};
